import { ButtonProps } from 'src/components/Button';
import { Visit, VisitStatus } from 'src/models/visit/_types';
import { getVisitStatus } from 'src/models/visit/utils';

export type VisitStatusButtonIcon = 'check' | 'times';

export type VisitStatusButtonStyle = {
  color: NonNullable<ButtonProps['color']>;
  icon?: VisitStatusButtonIcon;
};

const STATUS_STYLE_BY_STATUS: Partial<
  Record<VisitStatus, VisitStatusButtonStyle>
> = {
  [VisitStatus.Registered]: { color: 'primary' },
  [VisitStatus.Reserved]: { color: 'primary' },
  [VisitStatus.Completed]: { color: 'success', icon: 'check' },
  [VisitStatus.NoShowed]: { color: 'error', icon: 'times' },
  [VisitStatus.Cancelled]: { color: 'error', icon: 'times' },
  [VisitStatus.LateCancelled]: { color: 'error', icon: 'times' },
};

const DEFAULT_VISIT_STATUS_BUTTON_STYLE: VisitStatusButtonStyle = {
  color: 'primary',
};

export const getVisitStatusButtonStyle = (
  visit: Visit
): VisitStatusButtonStyle =>
  STATUS_STYLE_BY_STATUS[visit.status] ?? DEFAULT_VISIT_STATUS_BUTTON_STYLE;

export const getVisitStatusButtonLabel = (visit: Visit) =>
  getVisitStatus(visit) || 'None';

export const getVisitStatusButtonVariant = (
  style: VisitStatusButtonStyle,
  compact: boolean
): NonNullable<ButtonProps['variant']> =>
  compact || !style.icon ? 'bordered' : 'prominent';

export const getVisitStatusButtonCompactSx = (compact: boolean) =>
  compact
    ? {
        minHeight: 28,
        py: 0,
        px: 1,
        fontSize: '0.875rem',
        fontWeight: 500,
      }
    : undefined;
